import { PlanInterval } from '@dtx-company/true-common/src/types/PlanInterval'

/**
 * Provides a display-friendly name for the given PlanInterval.
 *
 * This should always be used when displaying the name to ensure
 * consistency across the application.
 *
 * The name casing may be changed by js or css for display purposes.
 *
 * @see getPlanTypeName
 * @see getPlanName
 *
 * @example
 * const PlanTypeText = styled(Text)`
 *   text-transform: uppercase;
 * `
 * return (
 *   <>
 *     <PlanTypeText>{getPlanTypeName(props.planType)}</PlanTypeText>
 *     {getPlanIntervalName(props.interval)}
 *   </>
 * )
 */
export function getPlanIntervalName(planInterval: PlanInterval): string {
  switch (planInterval) {
    case PlanInterval.MONTHLY:
      return 'Monthly'
    case PlanInterval.YEARLY:
      return 'Annual'
    default:
      throw new Error(`Unrecognized plan interval: ${planInterval}`)
  }
}
